module.exports = __webpack_public_path__ + "static/media/screen1.8c454b66.gif";